<template>
  <div class="row">

    <div class="col-md-12">
      <create-transaction-form @on-submit="onCreateTransactionSubmit"></create-transaction-form>
    </div>
  </div>
</template>
<script>
  import CreateTransactionForm from './Forms/CreateTransactionForm.vue'

  export default {
    components: {
      CreateTransactionForm
    },
    data () {
      return {

        createTransactionModel: {}
      }
    },
    methods: {

      onCreateTransactionSubmit (model, isValid, validateObject) {
        model.saveTransactionButtonText = 'Saving Transactions ...'
        
        this.$http.post('/transactions', {
          
          transaction_date: model.transactionDate,
          amount: model.amount,
          remark: model.description,
          type_id: model.transactionType,
          category_id: model.category_id,
          bank_id: '3',
          account_number: '0039392311',
          transaction_id: this.getTransactionID()
        })
        .then(response =>{
          if(response.data.created_at){
            model.saveTransactionButtonText = 'Transaction Saved.'
            model.amount = ''
            model.description = ''
            model.transactionDate = ''
            model.transactionType = '',
            model.category_id = ''

            this.$nextTick(function () {
              validateObject.reset()
            })
          }else{
            model.saveTransactionButtonText = 'Transaction Was Not Saved.'
          }
        })
        .catch(error => {
          console.error(error);
        });
      },

      getTransactionID () {
        var currentTimestamp = Date.now()
        return currentTimestamp
      }
    }
  }
</script>
<style>
</style>
